import { faPlus, faTrashCan } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

import { ButtonSizeVariants, ButtonVariants } from 'constants/common';
import { Page } from 'constants/report-document-builder';
import { Button } from 'shared-components';

type Props = {
  pages: Page[];
  activeId: number;
  onActivate: (id: number) => void;
  onAdd: () => void;
  onDelete: (id: number) => void;
};

const MiniA4Block = ({ pages, activeId, onActivate, onAdd, onDelete }: Props) => {
  const { t } = useTranslation();

  return (
    <div className="mt-14 flex justify-center overflow-y-auto">
      <ol className="flex flex-col gap-1 overflow-y-auto overflow-x-hidden">
        {pages.map((page, index) => (
          <li key={page.id} className="flex items-start gap-3">
            <span className="w-1 text-sm text-neutral-800 dark:text-neutral-200">{index + 1}</span>
            <div className="relative group">
              <div
                onClick={() => onActivate(page.id)}
                className={`relative group w-[10.375rem] h-[14.375rem] rounded-md bg-white border overflow-hidden transition ${
                  page.id === activeId ? 'border-primary-500' : 'border-neutral-200'
                }`}
              >
                <div
                  className="pointer-events-none w-[49.375rem] h-[70rem] scale-[0.21] origin-top-left"
                  dangerouslySetInnerHTML={{ __html: page.html }}
                />

                {pages.length > 1 && (
                  <Button
                    variant={ButtonVariants.OUTLINE}
                    onClick={(e) => {
                      e.stopPropagation();
                      onDelete(page.id);
                    }}
                    className="absolute top-1 right-1 px-1 !h-6 !opacity-0 group-hover:!opacity-100"
                  >
                    <FontAwesomeIcon icon={faTrashCan} className="w-3.5 h-3.5" />
                  </Button>
                )}
              </div>
            </div>
          </li>
        ))}
        <div className="flex justify-center">
          <Button onClick={onAdd} leftIcon={faPlus} size={ButtonSizeVariants.SM} className="w-[9rem] mb-3">
            {t('AddNewPage')}
          </Button>
        </div>
      </ol>
    </div>
  );
};

export default MiniA4Block;
